import { AfterContentInit, Component, NO_ERRORS_SCHEMA, OnDestroy, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { Subscription } from 'rxjs';
import { CasiOwnerUser, CasiProjectLabel, CasiStoryEstimate, CasiStoryPriority, CasiStoryStatus, CasiStoryType, CasiUserStory, IProject, Project, ProjectType, StoryPriority, StoryState, StoryType, User as UserModel } from '../../models/models.lib';
import { blastKeys, defaultGridPageSize, FormModes } from '../../common/constants.lib';
import { LoadingIndicatorService } from '../../shared/loading-indicator.service';
import { UserStoryService } from '../../tracker/user-story.service';
import { sortStatus } from '../../common/utils.lib';
import { ActivatedRoute } from '@angular/router';
import { LoggerService } from '../../shared/logger.service';
import { storyOptions, UserStorySearchOptions } from '../../common/obj.lib';
import { IconsModule } from '@progress/kendo-angular-icons';
import { ButtonsModule, KENDO_BUTTONS } from '@progress/kendo-angular-buttons';
import { DropDownsModule, KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import { MeService } from '../../auth/me.service';
import { UserStoryComponent } from '../user-story/user-story.component';
import { ProjectUserService } from '../../tracker/project-user.service';
import { SocketService } from '../../shared/socket.service';

@Component({
  selector: 'app-user-story-view',
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule,
    IconsModule,
    ButtonsModule,
    KENDO_BUTTONS,
    DropDownsModule,
    KENDO_DROPDOWNS,
    UserStoryComponent
  ],
  templateUrl: './user-story-view.component.html',
  styleUrl: './user-story-view.component.scss'
})
export class UserStoryViewComponent implements OnInit, OnDestroy, AfterContentInit {
  public projects: Project[] = [];
  public users: UserModel[] = [];
  public projectUsers: CasiOwnerUser[] = [];
  public storyStatus: CasiStoryStatus[] = [];
  public storyTypes: CasiStoryType[] = [];
  public storyPriorities: CasiStoryPriority[] = [];
  public storyEstimates: CasiStoryEstimate[] = [];
  public projectLabels: CasiProjectLabel[] = [];
  public rawData: CasiUserStory[] = [];

  public selectedUserStory: CasiUserStory = this.rawData[0];
  public selectedUserStoryId: string | null = null;
  public currentUser: UserModel | undefined = this.users[0];
  public storyOption: string = storyOptions[0].value;

  public editWinOpen: boolean = false;
  public formMode: FormModes = FormModes.NOTSET;
  public searchStr: string = '';
  public pageSize = defaultGridPageSize;
  public searchOptions: UserStorySearchOptions = new UserStorySearchOptions({
    dashboardStr: this.storyOption,
    email: this.currentUser?.email
  });

  private _subs: Subscription[] = [];

  constructor(
    private logger: LoggerService,
    public faIcons: FaIconLibrary,
    private route: ActivatedRoute,
    private loadingIndictorService: LoadingIndicatorService,
    public userStoryService: UserStoryService,
    private me: MeService,
    private projectUserService: ProjectUserService,
    private socketService: SocketService
  ) {
    faIcons.addIcons(...all);
  }

  //#region NG event handlers

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
    this.loadingIndictorService.loadingOff();

    this._subs.push(this.route.data.subscribe(({
      projects,
      users,
      storyStatus,
      storyTypes,
      storyPriorities,
      storyEstimates,
      projectLabels
    }) => {
      this.projects = projects;
      this.users = users;
      this.storyStatus = storyStatus.sort(sortStatus);
      this.storyTypes = storyTypes;
      this.storyPriorities = storyPriorities;
      this.storyEstimates = storyEstimates;
      this.projectLabels = projectLabels;
      // this.logger.debug(`ngOnInit:users: `, this.users);
      // this.logger.debug(`ngOnInit:storyStatus: `, this.storyStatus);
      // this.logger.debug(`ngOnInit:storyEstimates: `, this.storyEstimates);
      // this.logger.debug(`ngOnInit:storyTypes: `, this.storyTypes);
      // this.logger.debug(`ngOnInit:projectLabels: `, this.projectLabels);
      let found = this.users.find((value, index, array) => {
        return value.id == this.me.userId;
      });
      if (found) {
        this.currentUser = found;
        this.searchOptions = { ...this.searchOptions, ...{ email: found.email } };
        // this.logger.debug('CURRENT USER', this.currentUser);
      }
    }));

    this.route.paramMap.subscribe(params => {
      this.selectedUserStoryId = params.get('id');
    })

    this._subs.push(this.socketService.onRefresh()
      .subscribe((args: any | unknown) => {
        this.logger.debug(`onRefresh: `, args);
        if (args && args.blastKey === blastKeys.USER_STORY_UPDATED) {
          this.doDataRequest();
        }
      }));
  }

  ngOnDestroy(): void {
    this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }

  ngAfterContentInit(): void {
    this.doDataRequest();
  }

  //#endregion

  private doDataRequest(): void {
    this.userStoryService
      .searchForUserForId(this.searchOptions.searchStr, this.searchOptions, this.selectedUserStoryId)
      .then(data => {
        if (data) {
          this.rawData = data;
          this.selectedUserStory = data[0];
          //  this.selectedUserStoryId = data[0].id ? data[0].id : undefined;
          this.projectUserService.getByProjectId(this.selectedUserStory.project_id!)
            .then((data: any) => {
              this.projectUsers = data.map((r: any) => CasiOwnerUser.createFromProjectUser(r));
              this.logger.debug('doDataRequest: projectUsers', this.projectUsers);
              this.formMode = FormModes.EDIT;
              // this.showTitle = setTitle(this.formMode, 'PROJECT');
              //this.editWinOpen = true;
            }).catch((error: any) => {
              this.logger.error(`doDataRequest:error:`, error);
            });
        } else {
          this.rawData = [];

        }
      })
      .catch(err => {
        this.logger.error(`doDataRequest:error: `, err);
      });

  }

}
